import { render, staticRenderFns } from "./SettleFbpClaims.vue?vue&type=template&id=bd21049c&scoped=true"
import script from "./SettleFbpClaims.vue?vue&type=script&lang=js"
export * from "./SettleFbpClaims.vue?vue&type=script&lang=js"
import style0 from "./SettleFbpClaims.vue?vue&type=style&index=0&id=bd21049c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd21049c",
  null
  
)

export default component.exports